module.exports = __webpack_public_path__ + "static/deck-106300a4bf7784b7401f7d911489dccb.jpg";